import { render, staticRenderFns } from "./EmployerPhone.vue?vue&type=template&id=6fd09f8f&scoped=true"
import script from "./EmployerPhone.vue?vue&type=script&lang=ts"
export * from "./EmployerPhone.vue?vue&type=script&lang=ts"
import style0 from "./EmployerPhone.vue?vue&type=style&index=0&id=6fd09f8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd09f8f",
  null
  
)

export default component.exports